<template>
  <div id="reporteador">
    <div
      class="separador text-center mt-5 py-5"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      <p class="blockd fXG azuloscuro">Tickets Registrados</p>

      <div>
        <button class="btnaction px-5 bold" @click="logout()">
          Cerrar sesión
        </button>
      </div>


    </div>

    <div class="container-fluid">
      <!-- <div class="row pb-5">
        <div class="col-12 blockd fG azuloscuro">Semana 1</div>
      </div>-->

      <div class="row">
        <div class="col-6 py-5">
          <router-link class="btn btn-danger" to="/reportes/informe"
            >Participaciones &raquo;
          </router-link>
        </div>
      </div>

      <b-tabs content-class="mt-3 row">
        <b-tab title="Usuarios" active>
          <div class>
            <div class="col-12 azuloscuro pt-5 pb-3">
              <span class="blockd fG">Usuarios</span>
              (Total: {{ users_array.length }})
            </div>
            <div class="col-12">
              <download-excel
                :data="this.users_array"
                name="Usuarios Verano Cinepolis.xls"
              >
                <button class="btn btn-danger">Exportar Usuarios</button>
              </download-excel>
            </div>
            <div class="col-12">
              <v-client-table
                :columns="columns_users"
                v-model="users_array"
                :options="options_users"
              ></v-client-table>
            </div>
          </div>
        </b-tab>
        
      </b-tabs>
    </div>

    <Footer></Footer>
    <!-- <Glyphicons></Glyphicons> -->
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 27;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import * as fb from "../firebase";
import * as moment from "moment";
import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    // Glyphicons,
  },
  data() {
    return {
      columns: [
        "id",
        "week",
        "nombre",
        "apellido",
        "apellido2",
        "email",
        "puntos_convertidos",
        "puntos_acumulados",
        "status",
        "tipo_cupon",
        "codigo_dulceria",
        "codigo_oxxo",
        "tiempo",
        "segundos",
        "intento_trampa",
        // "started_on",
        // "finished_on",
        // "diferencia_segundos_user",
        "created_on_server",
        "finished_on_server",
        "diferencia_segundos_servidor",
      ],
      data: null,
      options: {
        perPage: 100,
        headings: {
          id: "Ticket UID",
          week: "Semana",
          nombre: "Nombre",
          apellido: "Apellido",
          apellido2: "Segundo Apellido",
          email: "Email",
          puntos_convertidos: "Puntos",
          puntos_acumulados: "Puntos agregados por ticket",
          status: "Status Participación",
          tipo_cupon: "Tipo Cupón",
          codigo_dulceria: "Cupón Dulcería",
          codigo_oxxo: "Cupón OXXO",
          tiempo: "Tiempo Participación",
          segundos: "Segundos Participación",
          intento_trampa:
            "Posible Trampa (si fecha, campo válido: Segundos Servidor)",
          // started_on: "Fecha Ini User",
          // finished_on: "Fecha Fin User",
          // diferencia_segs_user: "Segundos User",
          created_on_server: "Fecha Registro (Servidor)",
          finished_on_server: "Fecha Fin de Participación (Servidor)",
          diferencia_segundos_servidor: "Segundos Servidor",
        },
        editableColumns: [],
        sortable: [],
      },
      columns_users: [
        "user_id",
        "nombre",
        "apellido",
        "apellido2",
        "email",
        //"genero",
        "celular",
        "fecha_nacimiento",
        "edad",
        "club_cinepolis",
        // "no_cupones_registro",
        // "no_cupones_validos_oxxo",
        // "no_cupones_validos_dulceria",
        // "no_cupones_juego",
        "suma_puntos",
        "suma_time",
        "suma_time_txt",
        "num_tickets",
        "created_on",
        "dia_registro",
      ],
      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          apellido2: "Segundo Apellido",
          email: "Email",
          genero: "Genero",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          club_cinepolis: "Membresía Club Cinépolis",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: ["edad", "suma_puntos", "suma_time", "num_tickets"],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      mostrar_monto: false,
      monto: 0,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.init();
  },
  methods: {
    async init() {
      this.$store.dispatch("showLoader", true);
      await this.getUsers();
      await this.getTickets();
    },
    logout(){
        this.$store.dispatch("logoutReportes");
    },
    seleccionaStatusChange(status) {
      this.monto = 0;
      console.log(status);
      if (
        status == "$40 en productos de la Familia Coca-Cola en tiendas OXXO"
      ) {
        this.mostrar_monto = true;
      } else {
        this.mostrar_monto = false;
      }
    },
    async getTickets() {
      console.log("getting tickets");
      const docs = await ticketsCollection.get();

      await this.getAhora();

      this.tickets = [];
      docs.forEach((doc) => {
        let ticket = doc.data();
        //console.log(ticket.user_id );

        //if (ticket.user_id == "Vu7dm3jyJlNFCiVJdLov9ze2PeI2") return;

        ticket.id = doc.id;

        try {
          ticket.nombre = this.users[ticket.user_id].nombre;
        } catch (err) {
          ticket.nombre = "";
        }
        try {
          ticket.apellido = this.users[ticket.user_id].apellido;
        } catch (err) {
          ticket.apellido = "";
        }
        try {
          ticket.apellido2 = this.users[ticket.user_id].apellido2;
        } catch (err) {
          ticket.apellido2 = "";
        }
        try {
          ticket.email = this.users[ticket.user_id].email;
        } catch (err) {
          ticket.email = "";
        }
        try {
          ticket.celular = this.users[ticket.user_id].celular;
        } catch (err) {
          ticket.celular = "";
        }
        try {
          ticket.fecha_nacimiento = moment(
            this.users[ticket.user_id].fecha_nacimiento
          ).format("DD/MM/YYYY");
        } catch (err) {
          ticket.fecha_nacimiento = "";
        }

        try {
          ticket.tiempo = this.secondsToHms(ticket.time);
        } catch (err) {
          //console.log({ errortime: err });
          //console.log({errortimesuser: ticket.user.id});
        }


        try{
          ticket.tipo_cupon_1 = ticket.tipo_cupon;
        }catch(e){
          ticket.tipo_cupon = "";
        }

        ticket.segundos = ticket.time;
        ticket.puntos_convertidos = ticket.puntos_totales;

        try {
          ticket.week = this.getNumSemana(
            this.getFechaFormato(ticket.created_on_server.seconds)
          );
        } catch (err) {
          console.log({ weekerror: err });
          ticket.week = -1;
        }

        try {
          ticket.monto.toString();
        } catch (err) {
          ticket.monto = 0;
        }

        let mnms2 = false;
        try{
          if(ticket.mnms != undefined && ticket.mnms == true){
            mnms2 =  true;
          }
        } catch (err) {
          //ticket.monto = 0;
        }
        ticket.mnms = mnms2;

        if(ticket.mnms == true){
          ticket.puntos = ticket.puntos * 2;
        }
        


        this.sumaStatsUser(ticket.user_id, ticket.puntos, ticket.time);

        try {
          ticket.intento_trampa = moment
            .unix(ticket.intento_trampa.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.intento_trampa = "";
        }

        // ticket.diferencia_segundos_user = this.calculaDiferenciaTiempos(
        //   ticket.started_on,
        //   ticket.finished_on
        // );
        // console.log(ticket.diferencia_segundos_user);
        try {
          ticket.started_on = moment
            .unix(ticket.started_on.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.started_on = "";
        }
        try {
          ticket.finished_on = moment
            .unix(ticket.finished_on.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.finished_on = "";
        }

        try {
          ticket.diferencia_segundos_servidor = this.calculaDiferenciaTiempos(
            ticket.created_on_server,
            ticket.finished_on_server
          );
        } catch (e) {
          ticket.diferencia_segundos_servidor = "";
        }

        try {
          ticket.created_on = moment
            .unix(ticket.created_on.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.created_on = "";
        }

        try {
          ticket.created_on_server = moment
            .unix(ticket.created_on_server.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.created_on_server = "";
        }
        try {
          ticket.finished_on_server = moment
            .unix(ticket.finished_on_server.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.finished_on_server = "";
        }

        

        
        if (
          ticket.tipo_cupon ==
          "$40 en productos de la Familia Coca-Cola en tiendas OXXO"
        ) {
          try{
          this.users[ticket.user_id].no_cupones_validos_oxxo =
            this.users[ticket.user_id].no_cupones_validos_oxxo + 1;
          }catch(e){
            //
          }
        } else if (
          ticket.tipo_cupon == "1 Combo Cinépolis" ||
          ticket.tipo_cupon == "2 o más Combos Cinépolis"
        ) {
          try{
          this.users[ticket.user_id].no_cupones_validos_dulceria =
            this.users[ticket.user_id].no_cupones_validos_dulceria + 1;
          }catch(e){
            //
          }
        } else if (
          ticket.tipo_cupon != "no válido" ||
          parseInt(ticket.segundos) > 0
        ) {
          // // // try{
          // // // this.users[ticket.user_id].no_cupones_juego = this.users[ticket.user_id].no_cupones_juego + 1;
          // // // }catch(e){
          // // //   //
          // // // }
          
        }


        try{
          this.users[ticket.user_id].no_tickets_registrados = this.users[ticket.user_id].no_tickets_registrados + 1;
        }catch(e){
          //
        }

        try{
          if (ticket.status == "por validar") {
            this.users[ticket.user_id].no_tickets_por_validar =
              this.users[ticket.user_id].no_tickets_por_validar + 1;
          }
        }catch(e){
          //
        }
        
        if (ticket.tipo_cupon == "no válido") {
          try{
            this.users[ticket.user_id].no_tickets_no_validos =
              this.users[ticket.user_id].no_tickets_no_validos + 1;
          }catch(e){
          //
          }
        } else if (ticket.status != "por validar") {
          try{
            this.users[ticket.user_id].no_tickets_validos =
              this.users[ticket.user_id].no_tickets_validos + 1;
          }catch(e){
          //
          }
        }

        

        delete ticket.respuestas;

        this.tickets.push(ticket);
      });
      this.tickets = this.tickets.sort(this.custom_sort);
      //console.log({ tickets: this.tickets });

      this.setUsersArray();
      this.$store.dispatch("showLoader", false);
    },
    setUsersArray() {
      this.users_array = [];
      Object.keys(this.users).forEach((key) => {
        let obj = this.users[key];
        obj.user_id = key;
        obj.edad = moment().diff(obj.fecha_nacimiento, "years");
        //console.log(key, obj);
        this.users_array.push(obj);
      });
    },
    sumaStatsUser(user_id, puntos, time) {
      if (puntos == undefined) puntos = 0;
      if (time == undefined) time = 0;

      let multiplicador = 1;

      // console.log(user_id);
      // console.log(this.users[user_id]);

      if (this.users[user_id] == undefined) return;

      if (this.users[user_id].suma_puntos == undefined)
        this.users[user_id].suma_puntos = 0;


      

      try {
        this.users[user_id].suma_puntos += parseInt(puntos) * multiplicador;
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].suma_time == undefined)
        this.users[user_id].suma_time = 0;
      try {
        this.users[user_id].suma_time += parseInt(time);
        this.users[user_id].suma_time_txt = this.secondsToHms(
          this.users[user_id].suma_time
        );
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].num_tickets == undefined)
        this.users[user_id].num_tickets = 0;
      try {
        this.users[user_id].num_tickets++;
      } catch (err) {
        console.log(err);
      }
    },
    calculaDiferenciaTiempos(started, finished) {
      try {
        //console.log({ started: started.seconds });
        //console.log({ finished: finished.seconds });
        if (started.seconds == null || finished.seconds == null) return "error";
        let d1 = moment.unix(started.seconds);
        //console.log({ d1: d1 });
        let d2 = moment.unix(finished.seconds);
        //console.log({ d2: d2 });
        return d2.diff(d1, "seconds");
      } catch (err) {
        return "error";
      }
    },
    async getUsers() {
      console.log("getting users");
      //const docs = await usersCollection.limit(100).get();
      const docs = await usersCollection.get();
      //console.log({ userDocs: docs });
      this.users = {};
      docs.forEach((doc) => {
        let user = doc.data();
        //user.id = doc.id;
        //console.log(doc.id)

        try {
          if (user.created_on.seconds != undefined) {
            //console.log("encontro fecha nueva");
            user.created_on = moment
              .unix(user.created_on.seconds)
              .format("ddd, DD MMM YYYY HH:mm:ss");

            user.dia_registro = moment(user.created_on).format("DD MMM");
          } else {
            user.dia_registro = moment(user.created_on).format("DD MMM");
          }
        } catch (err) {
          console.log({ fecha_error: err });
        }

        delete user.puntos_acumulados;
        delete user.cupones_redimidos;
        user.suma_puntos = 0;
        user.suma_time = 0;
        user.no_tickets_registrados = 0;
        user.no_tickets_por_validar = 0;
        user.no_tickets_validos = 0;
        user.no_tickets_no_validos = 0;

        if(user.puntos_club_cinepolis != undefined && user.puntos_club_cinepolis != ''){
          user.suma_puntos = 3000;
        }


        // user.no_cupones_registro = 1;
        // user.no_cupones_validos_oxxo = 0;
        // user.no_cupones_validos_dulceria = 0;
        // user.no_cupones_juego = 0;

        // // try {
        // //   delete user.no_cupones_validos_oxxo;
        // // } catch (err) {
        // //   //err
        // // }
        // // try {
        // //   delete user.no_cupones_validos_dulceria;
        // // } catch (err) {
        // //   //err
        // // }
        // // try {
        // //   delete user.no_cupones_juego;
        // // } catch (err) {
        // //   //err
        // // }
        // // try {
        // //   delete user.no_cupones_registro;
        // // } catch (err) {
        // //   //err
        // // }

        //console.log({ fecha: user.dia_registro });

        this.users[doc.id] = user;
      });
      console.log({ users: this.users });
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    // procesaTickets(){
    //   this.tickets_procesados = []
    //   this.tickets.forEach(ticket => {

    //   })
    // },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    getNumSemana(fecha) {
      return parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    async getAhora() {
      this.$store.dispatch("showLoader", true);
      var thes = this;
      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      var getFecha = fb.functions.httpsCallable("getAhora");

      let res = null;
      await getFecha("{}")
        .then(function (result) {
          // Read result of the Cloud Function.
          console.log({ resultadoGetAhora: result });
          thes.ahora = thes.getFechaFormato(result.data._seconds);
          //console.log({ahora: thes.ahora})
        })
        .catch(function (error) {
          console.log({ errorgetahora: error });
        });

      this.$store.dispatch("showLoader", false);
    },
    async changeStatusCreacion(id, userId, value, email) {
      console.log({ changeStatus: id });
      console.log({ changeStatus: value });
      console.log({ changeStatus: email });

      this.$store.dispatch("showLoader", true);

      let puntos_a_sumar = 0;

      var qData = {
        email: email,
      };

      if (value == "1 Combo Cinépolis") {
        //revisar si son 100 o 500 puntos si llevan más de 2 combos registrados en la semana
        puntos_a_sumar = await this.$store.dispatch(
          "revisarSemanaTicketsUsuario",
          {
            id: id,
            userId: userId,
          }
        );

        const https = require("https");

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "envio-dulceria.php",
            JSON.stringify(qData),
            {
              emulateJSON: true,
              httpsAgent: new https.Agent({ rejectUnauthorized: false }),
              headers: {
                "Content-Type": "text/plain",
                //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
              },
            }
          )
          .then(
            async (response) => {
              // get body data

              console.log("envio mail");
              console.log(response);

              let res = response.body;
              if (res.status === "ok") {
                await this.$store.dispatch("actualizarCodigoTicketDulceria", {
                  id: id,
                  userId: userId,
                  codigo: res.cupon,
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                //this.getTickets();
                this.$store.dispatch("showLoader", false);
                //this.$store.dispatch("changeStatusCreacion", { id: id, status: value });
              } else {
                await this.$store.dispatch("actualizarCodigoTicketDulceria", {
                  id: id,
                  userId: userId,
                  codigo: "",
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                swal.fire("Oops", "Se han agotado los cupones.", "warning");
                this.$store.dispatch("showLoader", false);
                //this.getTickets();
              }
            },
            (error) => {
              // error callback
              this.$store.dispatch("showLoader", false);

              console.log("error callback");
              console.log(error);
            }
          );
      } else if (value == "2 o más Combos Cinépolis") {
        puntos_a_sumar = 500;

        const https = require("https");

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "envio-dulceria.php",
            JSON.stringify(qData),
            {
              emulateJSON: true,
              httpsAgent: new https.Agent({ rejectUnauthorized: false }),
              headers: {
                "Content-Type": "text/plain",
                //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
              },
            }
          )
          .then(
            async (response) => {
              // get body data

              console.log("envio mail");
              console.log(response);

              let res = response.body;
              if (res.status === "ok") {
                await this.$store.dispatch("actualizarCodigoTicketDulceria", {
                  id: id,
                  userId: userId,
                  codigo: res.cupon,
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                // this.getTickets();
                this.$store.dispatch("showLoader", false);
                //this.$store.dispatch("changeStatusCreacion", { id: id, status: value });
              } else {
                await this.$store.dispatch("actualizarCodigoTicketDulceria", {
                  id: id,
                  userId: userId,
                  codigo: "",
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                swal.fire("Oops", "Se han agotado los cupones.", "warning");
                // this.getTickets();
                this.$store.dispatch("showLoader", false);
              }
            },
            (error) => {
              // error callback
              this.$store.dispatch("showLoader", false);

              console.log("error callback");
              console.log(error);
            }
          );
      } else if (
        value == "$40 en productos de la Familia Coca-Cola en tiendas OXXO"
      ) {
        if (this.monto == 0) {
          this.$store.dispatch("showLoader", false);
          swal.fire(
            "Oops",
            "Ingresa el monto de productos participantes que contiene el ticket antes de continuar...",
            "warning"
          );
          return;
        }

        puntos_a_sumar = parseInt(Math.floor(this.monto / 40) * 10);

        const https = require("https");

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "envio-oxxo.php",
            JSON.stringify(qData),
            {
              emulateJSON: true,
              httpsAgent: new https.Agent({ rejectUnauthorized: false }),
              headers: {
                "Content-Type": "text/plain",
                //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
              },
            }
          )
          .then(
            async (response) => {
              // get body data

              console.log("envio mail");
              console.log(response);

              let res = response.body;
              if (res.status === "ok") {
                await this.$store.dispatch("changeStatusTicketValidacion", {
                  id: id,
                  userId: userId,
                  codigo: res.cupon,
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                //this.getTickets();
                this.$store.dispatch("showLoader", false);
                this.monto = 0;
                this.mostrar_monto = false;
                //this.$store.dispatch("changeStatusCreacion", { id: id, status: value });
              } else {
                await this.$store.dispatch("changeStatusTicketValidacion", {
                  id: id,
                  userId: userId,
                  codigo: "",
                  email: email,
                  puntos: puntos_a_sumar,
                  tipo_cupon: value,
                });
                swal.fire("Oops", "Se han acabado los cupones.", "warning");
                //this.getTickets();
                this.$store.dispatch("showLoader", false);
                this.monto = 0;
                this.mostrar_monto = false;
              }
            },
            (error) => {
              // error callback
              this.$store.dispatch("showLoader", false);

              console.log("error callback");
              console.log(error);
            }
          );
      } else if (value == "no válido") {
        //
        const https = require("https");

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "envio-no-valido.php",
            JSON.stringify(qData),
            {
              emulateJSON: true,
              httpsAgent: new https.Agent({ rejectUnauthorized: false }),
              headers: {
                "Content-Type": "text/plain",
                //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
              },
            }
          )
          .then(
            async (response) => {
              // get body data
              this.$store.dispatch("showLoader", false);

              console.log("envio mail");
              console.log(response);

              let res = response.body;

              if (res.status == "ok") {
                //swal.fire("Bien", "Correo de notificación enviado.", "success");
                await this.$store.dispatch("actualizarCodigoNoValido", {
                  id: id,
                  userId: userId,
                  email: email,
                  tipo_cupon: value,
                });
                //this.getTickets();
              } else {
                swal.fire("Oops", res.msg, "warning");
              }
            },
            (error) => {
              // error callback
              this.$store.dispatch("showLoader", false);

              console.log("error callback");
              console.log(error);
            }
          );
      }
    },
  },
};
</script>

